"use client";

import React, { useId, useMemo } from "react";
import { ResponsiveContainer, AreaChart, Area } from "recharts";

type Props = {
  color: string; // hex like "#22C55E"
  values: number[]; // y-series, x is just index
  height?: number; // optional, default 160
  className?: string; // optional wrapper class
};

const ListingAirComponentChart: React.FC<Props> = ({
  color,
  values,
  height = 160,
  className,
}) => {
  const gradId = useId();

  const data = useMemo(() => values.map((y, i) => ({ i, y })), [values]);

  if (!values?.length) return null;

  return (
    <div className={className}>
      <ResponsiveContainer width="100%" height={height}>
        <AreaChart
          data={data}
          margin={{ top: 8, right: 8, bottom: 8, left: 8 }}
        >
          <defs>
            <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.35} />
              <stop offset="60%" stopColor={color} stopOpacity={0.12} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>

          <Area
            type="monotone"
            dataKey="y"
            stroke={color}
            strokeOpacity={0.95}
            strokeWidth={2.2}
            fill={`url(#${gradId})`} // soft shadow under the line
            dot={false}
            activeDot={false}
            isAnimationActive
            animationDuration={500}
            connectNulls
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ListingAirComponentChart;
